import { useEffect, useState } from "react";

import dayjs from "dayjs";

const createUnixTimeFromNumberOfDays = ({ numberOfDays }) => {
  const HOURS = 24;
  const MINUTES = 60;
  const SECONDS = 60;
  return numberOfDays * HOURS * MINUTES * SECONDS;
};

const useDateRanges = () => {
  const [startOrEndOfCurrentYear, setStartOrEndOfCurrentYear] =
    useState(undefined);
  const [workAnniversaryRange, setWorkAnniversaryRange] = useState({
    start: undefined,
    end: undefined,
  });

  useEffect(() => {
    const today = dayjs().unix();
    const todayUnix = dayjs.unix(today).hour(0).minute(0).second(0).unix();
    const todayFixedYear = dayjs.unix(todayUnix).year(1970).unix();

    const FIFTEEN_DAYS = createUnixTimeFromNumberOfDays({ numberOfDays: 15 });
    const HALF_YEAR = createUnixTimeFromNumberOfDays({ numberOfDays: 90 });
    const start = todayFixedYear - FIFTEEN_DAYS;
    const end = todayFixedYear + HALF_YEAR;
    setWorkAnniversaryRange({ start, end });

    const currentYearStart = new Date(new Date().getFullYear(), 0, 1);
    const convertedToUnix = Math.floor(currentYearStart.getTime() / 1000);
    setStartOrEndOfCurrentYear(convertedToUnix);
  }, []);

  return {
    startOrEndOfCurrentYear,
    workAnniversaryRange,
  };
};

export default useDateRanges;
